import React, { useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import style from "./LicenseProductsList.module.sass";
import LicenseInfo from "../LicenseInfo/LicenseInfo";

function LicenseProductsList({ provider }) {
  const licenseCards = useMemo(() => {
    if (!provider?.products?.length) return [];

    return provider.products.flatMap((product) => {
      const licenses = Array.isArray(product.licenses) ? product.licenses : [];

      // sorting licenses
      const sorted = [...licenses].sort(
        (a, b) => (b.license_expire_time ?? 0) - (a.license_expire_time ?? 0)
      );

      // each license ==> separate card
      return sorted.map((license) => ({
        product,
        license,
      }));
    });
  }, [provider]);

  return (
    <>
      {licenseCards?.map(({ product, license }) => {
        return (
          <div key={license.id} className={style.licenseProduct}>
            <img
              src={product.product_icon}
              className={style.productImg}
              alt="product"
            />

            <div className={style.information}>
              <div className={style.productName}>
                {product.name_prod}{" "}
                <span className={style.productDuration}>
                  {product.license_name}
                </span>
              </div>

              <LicenseInfo
                licenseExpireTime={license.license_expire_time}
                product={product}
                license={license}
                moneyBackIcon={license.moneyBackIcon}
                createdTime={license.created_time}
                urlInstall={product.url_install}
                providerId={provider.id}
                itemName={product.item_name}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}

LicenseProductsList.propTypes = {
  provider: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array])
  ),
};
LicenseProductsList.defaultProps = {
  provider: null,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LicenseProductsList);
